import { DirectoryAddress } from '@/types'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export function useElectronicAddresses({ organizationSlug, siren }: { organizationSlug: string; siren: string }) {
  const normalizedSiren = siren.replace(/\s/g, '')

  return useQuery({
    queryKey: ['electronic_addresses', organizationSlug, normalizedSiren],
    queryFn: () =>
      axios
        .get<{ connected: boolean; entries: DirectoryAddress[] }>('/internal_api/electronic_addresses', {
          params: { organization_slug: organizationSlug, siren: normalizedSiren },
        })
        .then((response) => response.data),
    enabled: /^\d{9}$/.test(normalizedSiren),
    retry: false,
  })
}
